export const findOption = (option, list) => {
  const _option = list?.find((list) => list.value === option);
  return _option;
};
